import { createSelector } from 'reselect';

import { getIntegrations } from 'modules/app/selectors';
import { IntegrationTypeEnum } from 'modules/global/typing/enums/integrations.enum';
import { getSelectedDealer } from 'selectors/dealerSelectors';

/**
 * @returns {{ dealerConfiguration : import('./reducers').DealerConfigurationReducer}}
 */
const getRoot = state => state;

export const getArgument = (_, arg) => arg;

export const getState = createSelector(getRoot, ({ dealerConfiguration }) => dealerConfiguration);

export const isReady = createSelector(getState, (dealerConfiguration) => dealerConfiguration.isReady);

export const getAllIspaBrands = createSelector(getIntegrations, ({ [IntegrationTypeEnum.ISPA]: ispaConfig }) => ispaConfig?.brands ?? []);

export const getIspaBrandAssignments = createSelector(getSelectedDealer, ({ ispaBrandAssignments }) => ispaBrandAssignments);
